import { useCallback, useEffect, useState } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../../authConfig";
import ProductTaxonomyPLMUI from "../ProductTaxonomyPLMUI/ProductTaxonomyPLMUI";
import FreeTextEnrichmentPLMUI from "../FreeTextEnrichmentPLMUI/FreeTextEnrichmentPLMUI";
import { NavigationTabs } from "../../constants/constants";

interface ContentProps {
  productDevIdFromParams: string;
  seasonNumberFromParams: string;
  activeTab?: string;
}

const Content = ({
  productDevIdFromParams,
  seasonNumberFromParams,
  activeTab,
}: ContentProps) => {
  const [accessToken, setAccessToken] = useState("");

  const getAccessToken = useCallback(async () => {
    const msalInstance = new PublicClientApplication(msalConfig);
    let account = msalInstance.getAllAccounts()[0];
    const accessTokenRequest = {
      scopes: [process.env.REACT_APP_BACKEND_SCOPE].filter(Boolean) as string[],
      account: account,
    };

    // Awaiting till the msalInstance is initialized.
    await msalInstance.initialize();
    msalInstance
      .acquireTokenSilent(accessTokenRequest)
      .then((accessTokenResponse) => {
        setAccessToken(accessTokenResponse.idToken);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    getAccessToken();
  }, [getAccessToken]);

  let content;
  switch (activeTab) {
  case NavigationTabs.ProductTaxonomy:
    content = (
      <ProductTaxonomyPLMUI
        productDevId={productDevIdFromParams}
        seasonNumber={seasonNumberFromParams}
        accessToken={accessToken}
      />
    );
    break;
  case NavigationTabs.AdditionalProductInfo:
    content = (
      <FreeTextEnrichmentPLMUI
        productDevId={productDevIdFromParams}
        seasonNumber={seasonNumberFromParams}
        accessToken={accessToken}
      />
    );
    break;
  default:
    content = null;
  }

  return <>{content}</>;
};

export default Content;
